var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58881 0 0 3.58875 0 8C0 12.4113 3.58881 16 8 16C12.4112 16 16 12.4113 16 8C16 3.58875 12.4112 0 8 0ZM5.74741 12.8247C6.2065 13.431 6.75241 13.9681 7.36062 14.42C4.10225 14.0979 1.54838 11.3417 1.54838 8C1.54838 4.65831 4.10225 1.90209 7.36069 1.58003C6.75247 2.03191 6.20653 2.56903 5.74747 3.17528C4.68869 4.57347 4.12903 6.24188 4.12903 8C4.12903 9.75813 4.68866 11.4265 5.74741 12.8247Z",
    fill: "#000000"
  })));
}

export default SvgMoonIcon;